import React from 'react';
import { Loader2 } from 'lucide-react';

const SIZES = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
};

export default function Spinner({ size = 'md', className = '' }) {
  return <Loader2 className={`${SIZES[size] || SIZES.md} animate-spin text-seha-500 ${className}`} />;
}

// Full-section loading state for pages/panels gated on an initial data fetch —
// avoids showing an empty/stale shell while the first request is in flight.
export function PageLoader({ label = 'Loading…' }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-24 text-neutral-400">
      <Spinner size="lg" />
      <p className="text-sm font-medium">{label}</p>
    </div>
  );
}
